module.exports = __webpack_public_path__ + "assets/img/edit_1.51559152.svg";